import { Inject, Injectable } from '@angular/core';
import Env, { PRODUCT_AREA_DISPLAY_OPTION } from '../../env';

@Injectable({
    providedIn: 'root'
})
export class AreaMapService {
    private static readonly areaIdSuffixRegex = /(\d+)$/;
    private static readonly defaultAreaMapImageSrc = 'assets/img/purchase-flow-v2/product-area/areas-map.png';

    constructor(@Inject('ENV') private readonly env: Env) {}

    async resolveAreaMapImageSrc(value: string | number | null | undefined): Promise<string | null> {
        const areaMapConfig = this.env.AREA_MAP;
        const productAreaDisplayOption =
            areaMapConfig?.PRODUCT_AREA_DISPLAY_OPTION ?? PRODUCT_AREA_DISPLAY_OPTION.FULL_MAP;

        if (this.env.APP_NAME !== 'orebro' || productAreaDisplayOption === PRODUCT_AREA_DISPLAY_OPTION.FULL_MAP) {
            return this.env.AREA_MAP?.SVG_IMAGE_SRC ?? AreaMapService.defaultAreaMapImageSrc;
        }

        const orebroStaticBasePath =
            areaMapConfig?.OREBRO_STATIC_BASE_PATH ?? `${this.env.STATIC_CONTENT_BASE_URL}/orebro/product_areas`;
        const orebroDefaultImageSrc =
            areaMapConfig?.OREBRO_DEFAULT_IMAGE_SRC ?? `${orebroStaticBasePath}/orebro-lan.svg`;

        if (!value) {
            return orebroDefaultImageSrc;
        }

        const areaSuffix = this.getIdSuffix(value);

        if (!areaSuffix) {
            return orebroDefaultImageSrc;
        }

        const imageSrc = `${orebroStaticBasePath}/${areaSuffix}.svg`;
        const isImageAvailable = await this.imageExists(imageSrc);
        return isImageAvailable ? imageSrc : null;
    }

    private imageExists(imageSrc: string): Promise<boolean> {
        return new Promise((resolve) => {
            const image = new Image();
            image.onload = () => resolve(true);
            image.onerror = () => resolve(false);
            image.src = imageSrc;
        });
    }

    private getIdSuffix(value: string | number | null | undefined): string | null {
        if (value === null || value === undefined) {
            return null;
        }

        const valueString = String(value);
        const match = AreaMapService.areaIdSuffixRegex.exec(valueString);
        return match?.[1] ?? null;
    }
}
